"use strict";
// The original default card order for the advisor feed
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORIGINAL_CARD_ORDER = exports.AdvisorCardType = void 0;
var AdvisorCardType;
(function (AdvisorCardType) {
    AdvisorCardType["CREDIT_SCORE_CARD"] = "credit-score-card";
    AdvisorCardType["SWEEPSTAKES_STATUS_CARD"] = "sweepstakes-status-card";
    AdvisorCardType["FREE_COFFEE_CARD_POLICIFIED"] = "free-coffee-card-policified";
    AdvisorCardType["HOME_VALUE_CARD"] = "home-value-card";
    AdvisorCardType["HOME_EQUITY_CARD"] = "home-equity-card";
    AdvisorCardType["SALE_LISTINGS_CARD"] = "sale-listings-card";
    AdvisorCardType["SOLD_PROPERTIES_CARD"] = "sold-properties-card";
    AdvisorCardType["CRAIGSLIST_CARD"] = "craigslist-card";
    AdvisorCardType["SPIN_TO_WIN_CARD"] = "spin-to-win-card";
    AdvisorCardType["SPENDING_CARD"] = "spending-card";
    AdvisorCardType["MONTHLY_SPENDING_PLAID_UPSELL"] = "monthly-spending-plaid-upsell";
    AdvisorCardType["RECENT_SPENDING_CARD"] = "recent-spending-card";
    AdvisorCardType["SUBSCRIPTIONS_CARD"] = "subscriptions-card";
    AdvisorCardType["MONTHLY_SUBSCRIPTION_PLAID_UPSELL"] = "monthly-subscription-plaid-upsell";
    AdvisorCardType["TOP_MERCHANTS_CARD"] = "top-merchants-card";
    AdvisorCardType["TOP_MERCHANTS_PLAID_UPSELL"] = "top-merchants-plaid-upsell";
    AdvisorCardType["CASH_AND_STOCK_CARDS"] = "cash-and-stock-cards";
    AdvisorCardType["ALL_LIABILITIES"] = "all-liabilities";
    AdvisorCardType["NOTABLE_PEOPLE_TRADES_CARD"] = "notable-people-trades-card";
    AdvisorCardType["CRIME_REPORT_CARD"] = "crime-report-card";
    AdvisorCardType["CREATE_VEHICLE_CARD"] = "create-vehicle-card";
    AdvisorCardType["VEHICLE_VALUE_CARD"] = "vehicle-value-card";
    AdvisorCardType["REQUEST_LIEN_REPORT_CARD"] = "request-lien-report-card";
})(AdvisorCardType || (exports.AdvisorCardType = AdvisorCardType = {}));
exports.ORIGINAL_CARD_ORDER = [
    AdvisorCardType.CREDIT_SCORE_CARD,
    AdvisorCardType.SWEEPSTAKES_STATUS_CARD,
    AdvisorCardType.FREE_COFFEE_CARD_POLICIFIED,
    AdvisorCardType.HOME_VALUE_CARD,
    AdvisorCardType.HOME_EQUITY_CARD,
    AdvisorCardType.SALE_LISTINGS_CARD,
    AdvisorCardType.SOLD_PROPERTIES_CARD,
    AdvisorCardType.CRAIGSLIST_CARD,
    AdvisorCardType.SPIN_TO_WIN_CARD,
    AdvisorCardType.SPENDING_CARD,
    AdvisorCardType.MONTHLY_SPENDING_PLAID_UPSELL,
    AdvisorCardType.RECENT_SPENDING_CARD,
    AdvisorCardType.SUBSCRIPTIONS_CARD,
    AdvisorCardType.MONTHLY_SUBSCRIPTION_PLAID_UPSELL,
    AdvisorCardType.TOP_MERCHANTS_CARD,
    AdvisorCardType.TOP_MERCHANTS_PLAID_UPSELL,
    AdvisorCardType.CASH_AND_STOCK_CARDS,
    AdvisorCardType.ALL_LIABILITIES,
    AdvisorCardType.NOTABLE_PEOPLE_TRADES_CARD,
    AdvisorCardType.CRIME_REPORT_CARD,
    AdvisorCardType.CREATE_VEHICLE_CARD,
    AdvisorCardType.VEHICLE_VALUE_CARD,
    AdvisorCardType.REQUEST_LIEN_REPORT_CARD,
];
